import client from 'webpack-theme-color-replacer/client'
import forElementUI from 'webpack-theme-color-replacer/forElementUI'
// 注意项目里的引入路径
import appConfig from '@/config'

export let curColor = appConfig.themeColor
export let curBlackColor = appConfig.blackColor

// 动态切换主题色
export function changeThemeColor(newColor, newBlackColor) {
  let blackColor = newBlackColor || curBlackColor
  let href = window.location.href
  let url = '/'
  if (href.indexOf('pc') !== -1) {
    url = '/pc/'
  }
  var options = {
    newColors: [...forElementUI.getElementUISeries(newColor), blackColor],
    changeUrl(cssUrl) {
      return `${url}${cssUrl}`
    },
  }
  return client.changer.changeColor(options, Promise).then(() => {
    curColor = newColor
    curBlackColor = blackColor
    sessionStorage.setItem('theme_color', curColor)
    sessionStorage.setItem('black_color', curBlackColor)
  })
}

export function initThemeColor() {
  const savedColor = sessionStorage.getItem('theme_color')
  const savedColor2 = sessionStorage.getItem('black_color')
  if (savedColor) {
    curColor = savedColor
    curBlackColor = savedColor2
    changeThemeColor(savedColor, savedColor2)
  }
}
